import React, {ForwardedRef, forwardRef} from 'react';
import {Platform, ScrollView as RNScrollView} from 'react-native';
import {ScrollView as RNGHScrollView, NativeViewGestureHandlerProps} from 'react-native-gesture-handler';
import {
  KeyboardAwareScrollView,
  KeyboardAwareScrollViewProps,
  KeyboardAwareScrollViewRef,
} from 'react-native-keyboard-controller';
import {IOSInAppBrowserVideoAdScrollView} from './iOSInAppBrowserVideoAdScrollView/IOSInAppBrowserVideoAdScrollView';
import {style} from './ScrollView.style';
import {iOSInAppBrowser} from 'ui/helpers';

type ScrollViewProps = KeyboardAwareScrollViewProps & NativeViewGestureHandlerProps;

export type {ScrollViewProps};

const ScrollView = forwardRef<RNScrollView | null, ScrollViewProps>(
  (
    {children, scrollEnabled, onScroll, contentContainerStyle: customContentContainerStyle, bottomOffset, ...props},
    ref,
  ) => {
    if (iOSInAppBrowser) {
      return (
        <IOSInAppBrowserVideoAdScrollView
          ref={ref}
          onScroll={onScroll}
          scrollEnabled={scrollEnabled}
          style={customContentContainerStyle}
        >
          {children}
        </IOSInAppBrowserVideoAdScrollView>
      );
    }

    return (
      <KeyboardAwareScrollView
        ScrollViewComponent={RNGHScrollView}
        contentContainerStyle={[style.contentContainerStyle, customContentContainerStyle]}
        onScroll={onScroll}
        showsVerticalScrollIndicator={false}
        scrollEventThrottle={16}
        ref={ref as ForwardedRef<KeyboardAwareScrollViewRef>}
        scrollEnabled={scrollEnabled}
        bottomOffset={bottomOffset ?? (Platform.OS === 'ios' ? 60 : 0)}
        {...props}
      >
        {children}
      </KeyboardAwareScrollView>
    );
  },
);

ScrollView.displayName = 'ScrollView';
export {ScrollView};
